/**
 * Root Prefix Transform.
 */

var _ = require('../util');

module.exports = function (options, next) {

    var url = next(options);

    if (_.isString(options.root) && !url.match(/^(https?:)?\//)) {
        url = options.root + '/' + url;
    }

    return url;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-resource/src/url/root.js
 ** module id = 106
 ** module chunks = 0
 **/